import API from "./apiConfig"

export const getUserToken = () => {
  return API.get('/lizmap_tokens/generate').then(res => res.data)
}
